module.exports = __webpack_public_path__ + "static/media/Sama2.62583085.jpg";